import React from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import CompetenceHeader from '../components/competence/CompetenceHeader';
import CompetenceSituation from '../components/competence/CompetenceSituation';
import CompetenceProcess from '../components/competence/CompetenceProcess';
import CompetenceResults from '../components/competence/CompetenceResults';
import { competencesData } from '../data/competencesData';
import { Target } from 'lucide-react';

const CompetencePage = () => {
  const { competenceSlug } = useParams();

  const currentCompetence = competencesData[competenceSlug || ''] || {
    title: 'Compétence non trouvée',
    description: 'Cette compétence n\'est pas encore documentée.',
    icon: Target,
    situation: { context: '', challenge: '', solution: '' },
    processus: [],
    resultats: [],
    outils: []
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <section className="pt-32 pb-20">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <CompetenceHeader competence={currentCompetence} />
            <CompetenceSituation situation={currentCompetence.situation} />
            <CompetenceProcess processus={currentCompetence.processus} />
            <CompetenceResults resultats={currentCompetence.resultats} outils={currentCompetence.outils} />
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default CompetencePage;
